import { Flex, Link, Text } from "@chakra-ui/react";
import { ProjectDocument } from "~/core/types";
import RequiredIndicator from "../RequiredIndicator";

export default function TokenBalanceRequirement({
  project,
}: {
  project: ProjectDocument;
}) {
  if (!project?.wallet?.isTokenRequired) {
    return null;
  }

  return (
    <Flex direction="row" alignItems="center" mb={2}>
      <Text fontSize="13" color={"descText"}>
        Have at least{" "}
        <Link href={project.wallet?.token?.url} isExternal>
          <b>
            {project?.wallet?.token?.balance} {project?.wallet?.token?.symbol}
          </b>
        </Link>{" "}
        in your wallet
      </Text>
      <RequiredIndicator required={!project.wallet?.isTokenOptional} />
    </Flex>
  );
}
